export const DialogAction = {
    CLOSE: "CLOSE",
    END_TRIAL: "END_TRIAL",
    NAVIGATE: "NAVIGATE",
    AUTO_DISMISS: "AUTO_DISMISS",
    START_TRIAL: "START_TRIAL",
};
